import { useEffect, useState } from "react";
import "./medical-dashboard.css";
import ScheduleUpdateModal from "../modals/ScheduleUpdateModal";
import DeclineModal from "../modals/DeclineModal";
import { get, post, put } from "../../utility/fetchWeb";
import { get as gets } from "../../utility/fetch2";
import notification from "../../utility/notification";
import { useNavigate } from "react-router-dom";
import ZoomMeeting from "./ZoomMeeting";
import { PhoneIcon, VideoIcon } from "lucide-react";
import PatientManagementPage from "./Patient/ZoomPage";
import ZoomPage from "./Patient/ZoomPage";
import MainDashboard from "./MainDashboard";
import moment from "moment";
// import { came } from "@mui/material";
// import { IconButton } from "@mui/material";
const userInfo = JSON.parse(localStorage.getItem("USER_INFO"));

const generateDateRange = () => {
  const today = new Date();
  const dates = [];

  // Start from 7 days ago
  for (let i = -7; i <= 7; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    dates.push({
      date: date.getDate(),
      day: date.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase(),
      fullDate: date, // Keep full date for comparison
    });
  }

  return dates;
};

const MedicalDashboard = ({ data }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  // Function to handle flipping the card
  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // Initialize selectedDate with today's date
  const [selectedDate, setSelectedDate] = useState(new Date().getDate());
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [zoomData, setzoomData] = useState(null);
  const [showAll, setshowAll] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewSchedule, setIsNewSchedule] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState("");
  const [rescheduleTime, setRescheduleTime] = useState("");
  const [rescheduleReason, setRescheduleReason] = useState("");
  // Handler for rescheduling appointment
  const handleRescheduleAppointment = async (appointmentId) => {
    try {
      // Format appointDate as YYYY/MM/DD
      let formattedDate = "";
      if (rescheduleDate) {
        const dateObj = new Date(rescheduleDate);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        formattedDate = `${year}/${month}/${day}`;
      }
      // Build the payload according to the required structure
      const payload = {
        doctorEmployeeId: userInfo?.userId || 0,
        appointDate: formattedDate,
        appointTime: rescheduleTime,
        healthCareProviderId: singleAppointmentData?.healthCareProviderId || 0,
        description: singleAppointmentData?.description || "",
        id: appointmentId,
        rescheduleReason: rescheduleReason,
      };
      const response = await put(`/Appointment`, payload);
      if (
        response.message &&
        response.message.toLowerCase().includes("rescheduled")
      ) {
        notification({
          title: "Success",
          message: "Appointment rescheduled successfully",
          type: "success",
        });
        getWaiting();
        setIsRescheduleModalOpen(false);
      } else {
        notification({
          title: "Error",
          message: response.message || "Failed to reschedule appointment",
          type: "error",
        });
      }
    } catch (error) {
      notification({
        title: "Error",
        message: "Failed to reschedule appointment",
        type: "error",
      });
      setIsRescheduleModalOpen(false);
    }
  };
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [singleAppointmentData, setsingleAppointmentData] = useState(null);
  const [slots, setSlots] = useState([]);
  const [credentials, setcredentials] = useState([]);
  const [appointmentsThisMonth, setappointmentsThisMonth] = useState(0);
  const doctorId = sessionStorage.getItem("userId");

  const [takenDates, setTakenDates] = useState([]);

  // Generate dynamic dates
  const dates = generateDateRange();

  const navigate = useNavigate();

  const scheduleData = [
    { id: 0, day: "Monday", period: "1:00pm - 3:00pm", patients: 3 },
    { id: 1, day: "Tuesday", period: "1:00pm - 3:00pm", patients: 3 },
    { id: 2, day: "Wednesday", period: "1:00pm - 3:00pm", patients: 3 },
    { id: 3, day: "Thursday", period: "11:00am - 1:00pm", patients: 3 },
    { id: 4, day: "Friday", period: "11:00am - 1:00pm", patients: 3 },
    { id: 5, day: "Saturday", period: "2:00pm - 4:00pm", patients: 3 },
    { id: 6, day: "Sunday", period: "2:00pm - 4:00pm", patients: 3 },
  ];

  const getWaiting = async () => {
    try {
      // const data = await get(`/Appointment/doctor/${doctorId}`);
      const data = await get(
        `/Appointment/all-appointments-by-doctor/${userInfo.userId}?pageNumber=1&pageSize=100`
      );
      // setPatientData(data.data || []);

      console.log("Waiting patients: ", data);
      // if (data?.status === "success") {
      //   // Filter for pending appointments only
      const pendingAppointments = data?.data;
      // ?
      // .filter(
      //   (appointment) => appointment.statusText?.toLowerCase() === "pending"
      // );
      setPatientData(pendingAppointments || []);
      // } else {
      //   setPatientData([]);
      // }
    } catch (e) {
      console.log("Error: ", e);
      setPatientData([]);
    }
  };

  const getAppointmentDate = async () => {
    try {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1; // getMonth() is zero-based
      const data = await gets(
        `/appointment/doctor/${
          userInfo.userId
        }/appointment_calendar?year=${currentYear}&month=${7}`
      );
      // Extract all dates with appointments
      console.log(data);
      const days = data?.data?.months?.[0]?.days || [];
      setappointmentsThisMonth(data?.data?.months?.[0]?.totalAppointments || 0);
      const taken = days.map((day) => new Date(day.date).toDateString());
      setTakenDates(taken);
      // ...existing code...
    } catch (e) {
      console.log("Error: ", e);
      setPatientData([]);
    }
  };

  // appointment/doctor/234/appointment_calendar?year=2025&month=7

  const getWaitingSingle = async (id) => {
    try {
      // const data = await get(`/Appointment/doctor/${doctorId}`);
      const data = await get(`/Appointment/${id}`);
      // setPatientData(data.data || []);
      setsingleAppointmentData(data?.data);
      console.log("Waiting patients: ", data);
      // if (data?.status === "success") {
      //   // Filter for pending appointments only
      // const pendingAppointments = data?.data;
      // ?
      // .filter(
      //   (appointment) => appointment.statusText?.toLowerCase() === "pending"
      // );
      // setPatientData(pendingAppointments || []);
      // } else {
      //   setPatientData([]);
      // }
    } catch (e) {
      console.log("Error: ", e);
      setPatientData([]);
    }
  };

  const getSlots = async () => {
    try {
      const data = await get(
        `/Doctors/api/slots/availableByDoctorId?doctorId=${doctorId}`
      );
      console.log("Waiting slots: ", data);
      if (data.length > 0) {
        setSlots(data);
      } else {
        setSlots([]);
      }
    } catch (e) {
      console.log("Error: ", e);
      setSlots([]);
    }
  };

  useState(() => {
    getWaiting();
    // getWaitingSingle();
    getSlots();
  }, []);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const getStatusColor = (appointment) => {
    if (appointment.isCanceled || appointment.statusText == "Declined")
      return "#ff6b6b";
    if (appointment.statusText == "Pending") return "#4B8AFF";
    if (appointment.isAdmitted) return "#4ecdc4";
    return "#51cf66";
  };

  const getStatusText = (appointment) => {
    if (appointment.isCanceled) return "Canceled";
    else if (appointment.isAdmitted) return "Admitted";
    else return appointment?.statusText;
  };

  const handleScheduleClick = (schedule) => {
    setSelectedSchedule(schedule);
    setIsNewSchedule(false);
    setIsModalOpen(true);
  };

  const handleCreateNewSchedule = () => {
    setSelectedSchedule({});
    setIsNewSchedule(true);
    setIsModalOpen(true);
  };

  const handleAcceptAppointment = async (appointmentId) => {
    try {
      const response = await post(
        `/Appointment/appointments/${appointmentId}/accept-appointment`
      );
      if (response.message === "Appointment accepted.") {
        notification({
          title: "Success",
          message: "Appointment accepted successfully",
          type: "success",
        });
        getWaiting(); // Refresh the appointments list
        getWaitingSingle(appointmentId); // Refresh the appointments list
      }
    } catch (error) {
      notification({
        title: "Error",
        message: "Failed to accept appointment",
        type: "error",
      });
      console.error("Error accepting appointment:", error);
    }
  };

  const handleDeclineAppointment = async (appointmentId, reason) => {
    try {
      const response = await post(
        `/Appointment/appointments/${appointmentId}/decline`,
        {
          reason: reason,
        }
      );

      if (response.message === "Appointment declined and notifications sent.") {
        notification({
          title: "Success",
          message: "Appointment declined successfully",
          type: "success",
        });
        getWaiting();
        getWaitingSingle(appointmentId); // Refresh the appointments list
        // Refresh the appointments list
      }
    } catch (error) {
      notification({
        title: "Error",
        message: "Failed to decline appointment",
        type: "error",
      });
      console.error("Error declining appointment:", error);
    } finally {
      setIsDeclineModalOpen(false);
      setSelectedAppointmentId(null);
    }
  };

  useEffect(() => {
    getAppointmentDate();
  }, [selectedDate]);

  function parseZoomLinkFunction(zoomLink) {
    try {
      const url = new URL(zoomLink);

      // Extract basic URL components
      const protocol = url.protocol;
      const hostname = url.hostname;
      const port = url.port || null;
      let pathname = url.pathname;
      const search = url.search;
      const hash = url.hash || null; // Fragment identifier

      // Extract the value after '/s/' in the pathm
      const pathSegments = pathname.split("/");
      let sValue = null;
      if (pathSegments.length > 2 && pathSegments[1] === "s") {
        sValue = pathSegments[2];
      }

      // Extract the 'zak' query parameter
      const zak = url.searchParams.get("zak");

      // Attempt to decode the JWT payload of the 'zak' token (client-side decoding)
      let decodedZakPayload = null;
      if (zak) {
        try {
          const parts = zak.split(".");
          // JWTs have three parts: header.payload.signature
          if (parts.length === 3) {
            // The payload is base64url encoded. window.atob is for standard base64.
            // For base64url, you might need to adjust characters.
            // A safer way for base64url is to replace non-standard chars for window.atob
            let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
            // Pad with '=' if necessary
            while (base64.length % 4) {
              base64 += "=";
            }
            decodedZakPayload = JSON.parse(window.atob(base64));
          }
        } catch (jwtError) {
          console.warn(
            "Could not decode zak JWT payload (client-side):",
            jwtError.message
          );
          decodedZakPayload = "Error decoding JWT or invalid format";
        }
      }

      function removeFirstThreeSubstring(word) {
        // Start extracting from index 3 (the fourth character) to the end of the string.
        return word.substring(3);
      }
      // Collect all extracted parts into an object
      if (pathname.startsWith("/s/")) {
        // alert("true");
        pathname = removeFirstThreeSubstring(pathname);
      }
      // If pathname is now an empty string, set it to '/' for consistency if needed,
      // though for Zoom links like this, it will likely be empty.
      if (pathname === "") {
        pathname = "/";
      }
      return {
        originalLink: zoomLink,
        protocol: protocol,
        hostname: hostname,
        port: port,
        pathname: pathname,
        sValue: sValue, // The value after /s/ (e.g., '88587679837' which is likely the meeting ID)
        queryParams: Object.fromEntries(url.searchParams.entries()), // All query parameters as an object
        zak: zak, // The raw zak token
        decodedZakPayload: decodedZakPayload, // Decoded JWT payload (if valid)
        hash: hash,
      };
    } catch (error) {
      console.error("Failed to parse Zoom link:", error.message);
      return {
        error: "Invalid URL provided",
        details: error.message,
      };
    }
  }

  function extractZoomCredentialsPass(url) {
    try {
      const meetingNumber = url.match(/\/j\/(\d+)/)?.[1] || null;
      const password = url.match(/[?&]pwd=([^&]+)/)?.[1] || null;

      return {
        meetingNumber,
        password,
        isValid: !!meetingNumber,
      };
    } catch (error) {
      return {
        meetingNumber: null,
        password: null,
        isValid: false,
      };
    }
  }

  // Update the formatTime function to include date
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return {
      date: date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      }),
      time: date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }),
    };
  };

  return (
    <div className="w-100">
      {!showAll && (
        <div className="w-100">
          {/* Main Content */}
          <div className="main-content">
            {/* Header */}
            <div className="header">
              <div className="search-bar">
                <input type="text" placeholder="Search appointments" />
              </div>
              <div className="header-actions">
                <button className="manage-schedule-btn" onClick={toggleDrawer}>
                  ← Manage My Schedule
                </button>
              </div>
            </div>
            {/* Doctor Info */}
            <div className="doctor-info">
              <div className="doctor-avatar">
                <img src="/user-avater.png" alt="Doctor" />
              </div>
              <div className="doctor-details">
                <p className="greeting">Good Day</p>
                <h2 className="doctor-name">
                  Dr. {userInfo?.firstName} {userInfo?.lastName}
                </h2>
                {/* <p className="hospital">Healing Stripes Hospital, Lagos.</p> */}
              </div>
            </div>
            {/* Bookings Summary */}
            <div className="bookings-summary">
              <div className="summary-card">
                <span>Total Bookings for this month</span>
                <span className="booking-count">{appointmentsThisMonth}</span>
              </div>
            </div>
            {/* Date Selection */}
            <div className="date-section">
              <h3>Select Date</h3>
              <div className="date-picker">
                {dates.map((dateItem) => {
                  const isTaken = takenDates.includes(
                    dateItem.fullDate.toDateString()
                  );
                  return (
                    <div
                      key={dateItem.fullDate.toISOString()}
                      className={`date-item ${
                        selectedDate === dateItem.date ? "selected" : ""
                      } ${
                        dateItem.fullDate.toDateString() ===
                        new Date().toDateString()
                          ? "today"
                          : ""
                      } ${isTaken ? "taken-date" : ""}`}
                      onClick={() => setSelectedDate(dateItem.date)}
                    >
                      <span className="date-number">{dateItem.date}</span>
                      <span className="date-day">{dateItem.day}</span>
                    </div>
                  );
                })}
              </div>
            </div>{" "}
            {/* Appointments List */}
            <div style={{ display: "flex" }}>
              <div className="appointments-section w-40">
                <div className="appointments-list">
                  {patientData?.length > 0 ? (
                    patientData.map((appointment) => (
                      <div>
                        <div class="appointment-card2">
                          <img
                            src="/user-avater.png"
                            alt="Doctor"
                            class="appointment-card__image"
                          />
                          <div class="appointment-card__details">
                            <div class="appointment-card__header">
                              <p class="appointment-card__name">
                                {appointment.patientName}
                              </p>
                              <span
                                style={{
                                  backgroundColor: getStatusColor(appointment),
                                }}
                                class="appointment-card__status appointment-card__status-no-show status-badge"
                              >
                                {getStatusText(appointment)}
                              </span>
                            </div>
                            <div class="appointment-card__symptom">
                              <span class="appointment-card__symptom-indicator"></span>
                              <p class="appointment-card__symptom-text">
                                {appointment.description}
                              </p>
                            </div>
                            <p class="appointment-card__time-booking">
                              {moment(appointment.appointDate).format("ll")} |{" "}
                              {appointment.appointTime} | Online Booking
                            </p>
                          </div>
                          <span
                            onClick={() => {
                              // setcredentials(
                              //   extractZoomCredentialsPass(appointment.zoomJoinUrl)
                              // );
                              // setzoomData(
                              //   parseZoomLinkFunction(appointment.zoomStartUrl)
                              // );
                              // console.log(
                              //   parseZoomLinkFunction(appointment.zoomStartUrl)
                              // );
                              setsingleAppointmentData(appointment);
                            }}
                            class="appointment-card__arrow"
                          >
                            &gt;
                          </span>
                        </div>
                        {/* <div key={appointment.id} className="appointment-card2">
                        <div className="patient-avatar">
                          <img
                            src="/user-avater.png"
                            alt={appointment.patientName}
                          />
                        </div>
                        <div className="appointment-details">
                          <div className="patient-info">
                            <h4>{appointment.patientName}</h4>
                            <div className="appointment-meta">
                              <span className="appointment-time">
                                {appointment.appointTime}
                              </span>
                              <span className="appointment-type">
                                {appointment.description}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-8 flex-v-center">
                          <div className="appointment-status">
                            <span
                              className="status-badge"
                              style={{
                                backgroundColor: getStatusColor(appointment),
                              }}
                            >
                              {getStatusText(appointment)}
                            </span>
                          </div>
                          <div className="appointment-actions">
                            <button
                              onClick={() => {
                                localStorage.setItem(
                                  "appointmentId",
                                  appointment.id
                                );
                                navigate(
                                  `/doctor/patients/patient-details/${appointment.patientId}`
                                );
                              }}
                              className="action-btn"
                            >
                              View Profile
                            </button>
                            {appointment.statusText === "Pending" && (
                              <>
                                <button
                                  className="action-btn accept-btn m-r-10 m-l-10"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAcceptAppointment(appointment.id);
                                  }}
                                >
                                  Accept
                                </button>
                                <button
                                  className="action-btn decline-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedAppointmentId(appointment.id);
                                    setIsDeclineModalOpen(true);
                                  }}
                                >
                                  Decline
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div> */}
                      </div>
                    ))
                  ) : (
                    <div className="no-appointments">
                      <p>No pending appointments found</p>
                    </div>
                  )}
                </div>
              </div>
              {singleAppointmentData && (
                <div class="booking-form-container w-60 flex position-relative">
                  <button
                    style={{
                      width: "80px",
                      position: "absolute",
                      right: "0px",
                    }}
                    disabled={singleAppointmentData?.statusText === "Pending"}
                    onClick={(e) => {
                      e.stopPropagation();
                      setshowAll(true);
                      // handleAcceptAppointment(singleAppointmentData?.id);
                    }}
                    class="booking-form-button booking-form-button--accept"
                  >
                    Switch
                  </button>

                  <div class="booking-profile-section">
                    <img
                      src="/user-avater.png"
                      alt="Doctor"
                      class="booking-profile-image"
                    />
                    {/* <img src="your-image-path.png" alt="Profile of Goodness Chibueze" class="booking-profile-image"> */}
                    <h2 class="booking-profile-name">
                      {singleAppointmentData?.patientName}
                    </h2>
                    <div class="booking-profile-date-time">
                      <span class="booking-profile-date">April 16, 2023</span> |{" "}
                      <span class="booking-profile-time">12:30pm</span>
                    </div>
                    <p class="booking-profile-status">
                      <span
                        style={{
                          backgroundColor: getStatusColor(
                            singleAppointmentData
                          ),
                        }}
                        class="appointment-card__status appointment-card__status-no-show status-badge"
                      >
                        {getStatusText(singleAppointmentData)}
                      </span>
                      {/* {singleAppointmentData?.statusText} */}
                    </p>
                  </div>
                  <div class="booking-form-fields">
                    <div class="booking-form-group">
                      <label for="ageBracket" class="booking-form-label">
                        Age Bracket
                      </label>
                      <input
                        type="text"
                        id="ageBracket"
                        value="25 - 30"
                        class="booking-form-input"
                        readonly
                      />
                    </div>
                    <div class="booking-form-group">
                      <label for="gender" class="booking-form-label">
                        Gender
                      </label>
                      <input value={""} class="booking-form-input" />
                      {/* <select id="gender" class="booking-form-select">
                    <option value="">Select Option</option>
                  </select> */}
                    </div>
                    <div class="booking-form-group">
                      {/* <label for="consultReason" class="booking-form-label">
                        Why would you like to consult
                      </label>
                      <input value={""} class="booking-form-input" /> */}
                      {/* <select id="consultReason" class="booking-form-select">
                    <option value="">Select Option</option>
                  </select> */}
                    </div>
                    <div class="booking-form-group">
                      <label for="whyDrWynn" class="booking-form-label">
                        Why you want to see {userInfo.firstName}{" "}
                        {userInfo.lastName}?
                      </label>
                      <textarea
                        id="whyDrWynn"
                        class="booking-form-textarea"
                        value={singleAppointmentData?.description}
                      ></textarea>
                    </div>
                    {singleAppointmentData?.statusText === "Pending" && (
                      <div>
                        <button
                          disabled={
                            singleAppointmentData?.statusText !== "Pending"
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAcceptAppointment(singleAppointmentData?.id);
                          }}
                          class="booking-form-button booking-form-button--accept"
                        >
                          Accept Booking
                        </button>
                        <div className="flex">
                          <button
                            style={{
                              marginRight: "10px",
                              border: "#f0f968ff",
                              backgroundColor: "#f0f968ff",
                              color: "black",
                            }}
                            disabled={
                              singleAppointmentData?.statusText !== "Pending"
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedAppointmentId(
                                singleAppointmentData?.id
                              );
                              setIsRescheduleModalOpen(true);
                            }}
                            class="booking-form-button booking-form-button--reject"
                          >
                            Reschedule Booking
                          </button>
                          {/* Reschedule Modal */}
                          {isRescheduleModalOpen && (
                            <div className="modal-overlay">
                              <div
                                className="modal-content"
                                style={{
                                  maxWidth: 400,
                                  margin: "auto",
                                  background: "#fff",
                                  padding: 24,
                                  borderRadius: 8,
                                }}
                              >
                                <h3 style={{ marginBottom: 16 }}>
                                  Reschedule Appointment
                                </h3>
                                <div style={{ marginBottom: 12 }}>
                                  <label
                                    htmlFor="reschedule-date"
                                    style={{
                                      display: "block",
                                      marginBottom: 4,
                                    }}
                                  >
                                    New Date
                                  </label>
                                  <input
                                    id="reschedule-date"
                                    type="date"
                                    value={rescheduleDate}
                                    onChange={(e) =>
                                      setRescheduleDate(e.target.value)
                                    }
                                    style={{
                                      width: "100%",
                                      padding: 8,
                                      borderRadius: 4,
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                  <label
                                    htmlFor="reschedule-time"
                                    style={{
                                      display: "block",
                                      marginBottom: 4,
                                    }}
                                  >
                                    New Time
                                  </label>
                                  <input
                                    id="reschedule-time"
                                    type="time"
                                    value={rescheduleTime}
                                    onChange={(e) =>
                                      setRescheduleTime(e.target.value)
                                    }
                                    style={{
                                      width: "100%",
                                      padding: 8,
                                      borderRadius: 4,
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                  <label
                                    htmlFor="reschedule-reason"
                                    style={{
                                      display: "block",
                                      marginBottom: 4,
                                    }}
                                  >
                                    Reason for Reschedule
                                  </label>
                                  <textarea
                                    id="reschedule-reason"
                                    value={rescheduleReason}
                                    onChange={(e) =>
                                      setRescheduleReason(e.target.value)
                                    }
                                    style={{
                                      width: "100%",
                                      padding: 8,
                                      borderRadius: 4,
                                      border: "1px solid #ccc",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 8,
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      setIsRescheduleModalOpen(false)
                                    }
                                    style={{
                                      padding: "8px 16px",
                                      background: "#eee",
                                      border: "none",
                                      borderRadius: 4,
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleRescheduleAppointment(
                                        selectedAppointmentId
                                      )
                                    }
                                    style={{
                                      padding: "8px 16px",
                                      background: "#4B8AFF",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: 4,
                                    }}
                                    disabled={
                                      !rescheduleDate ||
                                      !rescheduleTime ||
                                      !rescheduleReason
                                    }
                                  >
                                    Confirm
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                          <button
                            disabled={
                              singleAppointmentData?.statusText !== "Pending"
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedAppointmentId(
                                singleAppointmentData?.id
                              );
                              setIsDeclineModalOpen(true);
                            }}
                            class="booking-form-button booking-form-button--reject"
                          >
                            Reject Booking
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="w-100 flex">
                      <button
                        disabled={!singleAppointmentData.zoomJoinUrl}
                        onClick={() => {
                          // navigate(
                          //   `/doctor/appointments/meet/${singleAppointmentData.id}`
                          // );
                          setcredentials(
                            extractZoomCredentialsPass(
                              singleAppointmentData.zoomJoinUrl
                            )
                          );
                          setzoomData(
                            parseZoomLinkFunction(
                              singleAppointmentData.zoomStartUrl
                            )
                          );
                          setshowAll(true);
                          console.log(
                            parseZoomLinkFunction(
                              singleAppointmentData.zoomStartUrl
                            )
                          );
                        }}
                        style={{
                          backgroundColor: getStatusColor(
                            singleAppointmentData
                          ),
                          width: "150px",
                          marginRight: "10px",
                        }}
                        class="booking--button w-100"
                      >
                        <VideoIcon style={{ color: "white" }} />
                      </button>
                      <button
                        disabled
                        style={{
                          backgroundColor: getStatusColor(
                            singleAppointmentData
                          ),
                          width: "150px",
                        }}
                        class="booking--button w-100"
                      >
                        <PhoneIcon style={{ color: "white" }} />
                      </button>
                    </div>
                    <div class="booking-health-record-status">
                      <button class="booking-health-record-button">
                        Health Record Not Available
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Schedule Management Drawer */}
          <div
            className={`drawer-overlay ${isDrawerOpen ? "open" : ""}`}
            onClick={toggleDrawer}
          ></div>
          <div className={`schedule-drawer ${isDrawerOpen ? "open" : ""}`}>
            <div className="drawer-header">
              <button className="close-btn" onClick={toggleDrawer}>
                ←
              </button>
              <h3>Manage My Schedule</h3>
            </div>
            <div className="schedule-table">
              <div className="table-header2">
                <div className="header-cell">Date</div>
                <div className="header-cell">Start Time</div>
                <div className="header-cell">End Time</div>
                <div className="header-cell">Status</div>
              </div>
              {slots?.map((slot, index) => {
                const startDateTime = formatTime(slot.startTimeUtc);
                const endDateTime = formatTime(slot.endTimeUtc);
                return (
                  <div
                    key={slot.id || index}
                    className="table-row2"
                    onClick={() => handleScheduleClick(slot)}
                  >
                    <div className="cell">{startDateTime.date}</div>
                    <div className="cell">{startDateTime.time}</div>
                    <div className="cell">{endDateTime.time}</div>
                    <div className="cell">
                      <span
                        className={`status-indicator ${
                          slot.isBooked ? "booked" : "available"
                        }`}
                      >
                        {slot.isBooked ? "Booked" : "Available"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
            <button
              className="update-schedule-btn"
              onClick={handleCreateNewSchedule}
            >
              Create New Schedule
            </button>
          </div>
          <ScheduleUpdateModal
            isOpen={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              setIsNewSchedule(false);
            }}
            schedule={selectedSchedule || {}}
            isNewSchedule={isNewSchedule}
          />
          <DeclineModal
            isOpen={isDeclineModalOpen}
            onClose={() => {
              setIsDeclineModalOpen(false);
              setSelectedAppointmentId(null);
            }}
            onDecline={(reason) =>
              handleDeclineAppointment(selectedAppointmentId, reason)
            }
          />

          {/* <PatientManagementPage/> */}
        </div>
      )}
      {showAll && (
        <ZoomPage
          setshowAll={setshowAll}
          singleAppointmentData={singleAppointmentData}
        />
      )}

      {zoomData && (
        // <ZoomMeeting
        //   sdkKey={process.env.REACT_APP_ZOOM_SDK_KEY}
        //   // signature={zoomSignature}
        //   meetingNumber={zoomData?.pathname}
        //   // password={zoomMeetingPassword}
        //   role={1}
        //   zak={zoomData?.zak}
        //   userName={userInfo.firstName}
        //   userEmail={'greenzone@yahoo.com'}
        // />
        <div>
          <ZoomMeeting
            meetingNumber={zoomData?.pathname}
            userName={userInfo?.firstName}
            userEmail={"greenzone@yahoo.com"} // Provide the host's email
            zak={zoomData?.zak}
            password={credentials?.password}
            role={1} // Set role to HOST (1)
          />
        </div>
      )}
    </div>
  );
};

export default MedicalDashboard;

{
  /* <div class="appointment-card">
    <img src="your-image-path.png" alt="Goodness Chibueze" class="appointment-card__image">
    <div class="appointment-card__details">
        <div class="appointment-card__header">
            <p class="appointment-card__name">Goodness Chibueze</p>
            <span class="appointment-card__status appointment-card__status--no-show">No Show</span>
        </div>
        <div class="appointment-card__symptom">
            <span class="appointment-card__symptom-indicator"></span>
            <p class="appointment-card__symptom-text">Heart Burn and Cough</p>
        </div>
        <p class="appointment-card__time-booking">10.30am | Online Booking</p>
    </div>
    <span class="appointment-card__arrow">&gt;</span>
</div> */
}
